export enum EnFooterStatus {
  DEFAULT_VIEW = 'default',
  NONE = 'none',
  PLUGINS_VIEW = 'plugins',
  SINGLE_PLUGIN_VIEW = 'plugins/',
  ONLINE_GAMING_VIEW = 'use-cases/online-gaming',
  QR_CODE_PAYMENTS = 'qr-code-payments',
  NODA_PRIME = 'stream-donations',
}
